import { httpClient } from "@/app/client/httpClient";
import { PageableRequest } from "@/types/PageableRequest";

class InformationService {
  async fetchInformation(id: number) {
    return await httpClient.admin.workers.information._id(id).$get();
  }

  async fetchInformationTargets(
    query?: PageableRequest<{
      ordering: string;
    }>
  ) {
    return await httpClient.admin.workers.information_target.$get({
      query: {
        ordering: "-information__created_at",
        ...query
      }
    });
  }

  markAsRead(informationId: number) {
    return httpClient.admin.workers.information_target.read.$post({
      body: {
        informationId: informationId
      }
    });
  }

  async fetchUnreadCount(): Promise<number> {
    const {
      count
    } = await httpClient.admin.workers.information_target.unread_count.$get();
    return count;
  }

  async openPushNotification(id: number): Promise<void> {
    await httpClient.admin.workers.information_target.open_push_notification.$post(
      {
        body: {
          informationId: id
        }
      }
    );
  }
}

export const informationService = new InformationService();
